import { formatPhoneForDisplay } from "./phone-format";

export const isTechnicalWarning = (text) =>
  /schools['’`]?\s*set to|schoolName left empty|unmappedColumns|json schema|empty \[\]|interpreter was unavailable|took too long|read locally/i.test(
    String(text || ""),
  );

const parentSlotCount = (passengers = []) =>
  Math.max(0, ...passengers.map((passenger) => (passenger.parents || []).length), 0);

export const findingsColumns = (extraction) => {
  const passengers = (extraction?.passengers || []).filter((passenger) => passenger.name);
  const slots = parentSlotCount(passengers);
  const columns = [{ key: "studentName", label: "Student Name" }];
  // One school for everyone is said once in the school card; the column only earns its place when rows differ.
  const schoolNames = new Set(passengers.map((passenger) => passenger.schoolName).filter(Boolean));
  if (schoolNames.size > 1) {
    columns.push({ key: "school", label: "School" });
  }
  columns.push({ key: "address", label: "Address" });
  if (slots <= 1) {
    columns.push({ key: "parentName", label: "Parent Name" });
    columns.push({ key: "parentPhone", label: "Parent Phone" });
  } else {
    for (let index = 0; index < slots; index += 1) {
      columns.push({ key: `parent${index + 1}Name`, label: `Parent ${index + 1} Name` });
      columns.push({ key: `parent${index + 1}Phone`, label: `Parent ${index + 1} Phone` });
    }
  }
  if (passengers.some((passenger) => passenger.pickupRouteName)) {
    columns.push({ key: "pickupRoute", label: "Morning route" });
  }
  if (passengers.some((passenger) => passenger.dropoffRouteName)) {
    columns.push({ key: "dropoffRoute", label: "Afternoon route" });
  }
  return columns;
};

const cellFor = (passenger, key) => {
  if (key === "studentName") return passenger.name || "";
  if (key === "school") return passenger.schoolName || "";
  if (key === "address") return passenger.addressGetOn || passenger.addressGetOff || "";
  if (key === "pickupRoute") return passenger.pickupRouteName || "";
  if (key === "dropoffRoute") return passenger.dropoffRouteName || "";
  if (key === "parentName") return passenger.parents?.[0]?.name || "";
  if (key === "parentPhone") return formatPhoneForDisplay(passenger.parents?.[0]?.phone || passenger.phone);
  const match = /^parent(\d+)(Name|Phone)$/.exec(key);
  if (match) {
    const parent = passenger.parents?.[Number(match[1]) - 1];
    if (!parent) return "";
    return match[2] === "Name" ? parent.name || "" : formatPhoneForDisplay(parent.phone);
  }
  return "";
};

export const buildFindings = (extraction, limit = 8) => {
  const columns = findingsColumns(extraction);
  const named = (extraction?.passengers || []).filter((passenger) => passenger.name);
  return {
    columns,
    rows: named.slice(0, limit).map((passenger) => columns.map((column) => cellFor(passenger, column.key))),
    totalRows: named.length,
  };
};

export const schoolPrompt = (extraction) => {
  const schools = (extraction?.schools || []).filter((school) => school.name);
  if (schools.length) {
    return {
      status: "found",
      title: schools.length === 1 ? "School in this file" : "Schools in this file",
      schools,
      question: null,
    };
  }
  return {
    status: "missing",
    title: "No school was found",
    schools: [],
    question:
      "These passengers need a school before anything can be created. Choose an option below — Continue stays off until you do.",
  };
};

export const publicWarnings = (extraction) =>
  (extraction?.warnings || []).filter((warning) => warning && !isTechnicalWarning(warning));
